import React from 'react';
import StretchText from '../../controls/StretchText';

const DataPoint = (props) => {

    return (
        <div className="data-point " >  {/* onClick={props.onClick}  givemethefinger*/}
            <div className="data-point-internal">
                <div className="title">{props.title}</div>
                <div className="data" style={props.dataStyle}>{props.dataPoint}</div>
                <div className="desc">{props.desc}</div>
            </div>
        </div>
    );
}

export default DataPoint;